/*
  Flowkeeper - Pomodoro timer for power users and teams
  Copyright (c) 2023 Constantine Kulak, Geoffrey Espagne

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation; either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

import {useContext, useState} from 'react';
import {
    Avatar,
    Dropdown,
    DropdownItem,
    DropdownList,
    MenuToggle,
    MenuToggleElement,
    ToolbarItem
} from '@patternfly/react-core';
import {Link} from 'react-router-dom';

import DataContext from '../context/DataContext';

import SettingsPage from '../pages/SettingsPage';
import SignOutPage from '../pages/SignOutPage';

function AccountDisplay() {

    const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
    const [isSignOutModalOpen, setIsSignOutModalOpen] = useState(false);

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const { data } = useContext(DataContext);

    const onDropdownToggle = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const onDropdownSelect = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const openSettings = () => {
        setIsSettingsModalOpen(!isSettingsModalOpen);
    };

    const openSignOut = () => {
        setIsSignOutModalOpen(!isSignOutModalOpen);
    };

    return data && data.isLoggedIn ?
        <>
            <SignOutPage isOpen={isSignOutModalOpen} setIsOpen={setIsSignOutModalOpen}/>
            <SettingsPage isOpen={isSettingsModalOpen} setIsOpen={setIsSettingsModalOpen}/>
            <ToolbarItem key='account-display'>
                <Dropdown
                    isOpen={isDropdownOpen}
                    onSelect={onDropdownSelect}
                    onOpenChange={(isOpen: boolean) => setIsDropdownOpen(isOpen)}
                    popperProps={{position: 'right'}}
                    toggle={(toggleRef: React.Ref<MenuToggleElement>) => (
                        <MenuToggle
                            ref={toggleRef}
                            onClick={onDropdownToggle}
                            isFullHeight
                            isExpanded={isDropdownOpen}
                            key="menu avatar"
                            icon={<Avatar src={data.userAvatar} alt=""/>} />
                    )}>
                    <DropdownList>
                        <DropdownItem key="settings" onClick={openSettings}>Settings</DropdownItem>
                        <DropdownItem key="signout" onClick={openSignOut}>Sign Out</DropdownItem>   
                    </DropdownList>
                </Dropdown>
            </ToolbarItem>
        </>
        :
        <Link to='/login'>Sign In</Link>;
}

export default AccountDisplay;